export default () => ({
  currentMonth: null,
  scheduleYear: null,
  entities: 'statistics',
  statistics: [],
  total: 0,
  current: null,
  ishidden: false
})



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/company/gadget/components/abstract-speciality/resources/data.js